import React from 'react';
export function LeadSection() {
  return <section className="py-16 bg-white" data-id="element-114">
      <div className="container mx-auto px-4 max-w-3xl" data-id="element-115">
        <div className="prose prose-lg prose-slate mx-auto" data-id="element-116">
          <h2 className="text-3xl font-bold text-center mb-8 text-slate-900" data-id="element-117">
            ¿Te suena familiar esta escena?
          </h2>

          <div className="bg-[#FDFBF7] p-8 rounded-2xl border border-[#E2E8F0] shadow-sm mb-8" data-id="element-118">
            <p className="italic text-slate-700 mb-0" data-id="element-119">
              "Miras el reloj. Son las 4 de la tarde. No has avanzado ni la
              mitad de lo que planeaste. La casa está en caos, los correos se
              acumulan y esa presión en el pecho no te deja respirar. Te miras
              al espejo y solo ves a alguien que 'no sirve'. Te sientes inútil,
              una carga para tu familia y un fraude en tu trabajo."
            </p>
          </div>

          <p className="text-slate-600 leading-relaxed" data-id="element-120">
            Si has sentido ese nudo en la garganta, quiero que sepas algo
            importante: <strong data-id="element-121">no estás sola y no estás rota.</strong>
          </p>

          <p className="text-slate-600 leading-relaxed mt-4" data-id="element-122">
            La sociedad nos enseñó que valemos según nuestro output. Si
            produces, vales. Si estás quieta, sobras. Por eso, cuando entras en
            parálisis por agotamiento, no solo pierdes tiempo; sientes que estás
            perdiendo tu importancia como ser humano.
          </p>
        </div>
      </div>
    </section>;
}